module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/column-sizing/column-sizing.component.css
// module id = ./src/app/examples/column-sizing/column-sizing.component.css
// module chunks = main